import OnboardingType from "../../../../../shared/onboarding/onboarding-type";
import { FETCH_TASK_STATUSES_ORDER, UPDATE_TASK_STATUSES_ORDER, TASK_STATUSES_ORDER_SET_PRISTINE, REORDER_TASK_STATUSES_ORDER } from "./actions";

interface ShootingDayOrderState {
  taskStatuses: any[];
  loading: boolean;
  selectedSceneIds: string[];
  pristine: boolean;
  readOnly: boolean;
  saving: boolean;
  onboardingSteps: OnboardingType[];
}

export const OnboardingStep1ClassName = 'scene-order-onboarding-step-1';
export const OnboardingStep2ClassName = 'scene-order-onboarding-step-2';
export const OnboardingStep3ClassName = 'scene-order-onboarding-step-3';
export const OnboardingStep4ClassName = 'scene-order-onboarding-step-4';

const defaultState: ShootingDayOrderState = {
  taskStatuses: [],
  loading: true,
  selectedSceneIds: [],
  pristine: true,
  readOnly: false,
  saving: false,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Task Status Order',
      content: `Drag statuses into the order you want them to appear on the board.`,
      disableBeacon: true
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_TASK_STATUSES_ORDER + "_PENDING": {
      return {
        ...state,
        loading: true,
        scenes: [],
        errors: null,
        pristine: true
      };
    }

    case FETCH_TASK_STATUSES_ORDER + "_FULFILLED": {
      return {
        ...state,
        taskStatuses: action.payload.data.statuses,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null,
        pristine: true
      };
    }

    case FETCH_TASK_STATUSES_ORDER + "_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors
      };
    }

    case REORDER_TASK_STATUSES_ORDER: {
      let taskStatuses = Array.from(state.taskStatuses);
      taskStatuses = reorderTaskStatuses(
        taskStatuses,
        action.meta.startIndex,
        action.meta.endIndex
      );

      return {
        ...state,
        taskStatuses,
        pristine: false
      };

    }
    case UPDATE_TASK_STATUSES_ORDER + "_PENDING": {
      return {
        ...state,
        saving: true,
        errors: null
      };
    }

    case UPDATE_TASK_STATUSES_ORDER + "_FULFILLED": {
      const updatedTaskStatuses = action.meta.taskStatuses;
      const newTaskStatuses = Array.from(state.taskStatuses);

      newTaskStatuses.forEach((newTaskStatus) => {
        const taskStatus = updatedTaskStatuses.find((taskStatus) => taskStatus.id === newTaskStatus.id);
        newTaskStatus.order = taskStatus.order;
      });

      newTaskStatuses.sort((a, b) => a.order - b.order);
      return {
        ...state,
        taskStatuses: newTaskStatuses,
        saving: false,
        errors: null,
        pristine: true
      };
    }

    case UPDATE_TASK_STATUSES_ORDER + "_REJECTED": {
      return {
        ...state,
        days: action.meta.days,
        errors: action.payload.response.data.errors,
        saving: false
      };
    }

    case "SCENES_SCRIPT_DAY_TOGGLE_SELECTION_IN_GROUP": {
      const sceneId = action.meta.sceneId;

      const selectedSceneIds: any[] = state.selectedSceneIds;
      const index: number = selectedSceneIds.indexOf(sceneId);

      // if not selected - add it to the selected items
      let shallow: any[] = [];
      if (index === -1) {
        shallow = [...selectedSceneIds, sceneId];
      } else {
        // it was previously selected and now needs to be removed from the group
        shallow = [...selectedSceneIds];
        shallow.splice(index, 1);
      }

      return {
        ...state,
        selectedSceneIds: shallow
      };
    }

    case "SCENES_SCRIPT_DAY_SET_DRAGGING_SCENE_ID": {
      return {
        ...state,
        draggingSceneId: action.meta.sceneId
      };
    }

    case "SCENES_SCRIPT_DAY_UNSELECT_ALL": {
      return {
        ...state,
        selectedSceneIds: []
      };
    }

    case "SCENES_SCRIPT_DAY_MULTI_SELECT_TO": {
      return state;
    }

    case TASK_STATUSES_ORDER_SET_PRISTINE: {
      return {
        ...state,
        pristine: false
      };
    }

    default:
      return state;
  }
};

const reorderTaskStatuses = (list, sourceIndex, destinationIndex) => {
  const result: any[] = Array.from(list);
  result[sourceIndex].order = destinationIndex + 1;

  if (sourceIndex > destinationIndex) {
    for (let i = destinationIndex; i < sourceIndex; i++) {
      result[i].order++;
    }
  }

  if (sourceIndex < destinationIndex) {
    for (let i = sourceIndex + 1; i <= destinationIndex; i++) {
      result[i].order--;
    }
  }

  const [removed] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, removed);

  return result;
};

export default reducer;
